<div
  appFullscreenToggle
  right="2.5rem"
  top="0.75rem"
  class="rounded-lg fixed left-0 right-0 bottom-0 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 shadow-lg transition-transform duration-300 ease-in-out transform translate-y-0 h-[50vh] py-2 px-0.5">
  <div class="flex justify-between px-4">
    <div class="text-lg dark:text-white">{{ dialogTitle }}</div>
    <div class="flex-grow-1"></div>
    <app-button
      type="button"
      class="mr-2"
      (click)="openInNewTab()">
      {{ activeTab.linkTitle }}
    </app-button>
    <app-button-group [buttonLabels]="tabs()"
      (buttonClick)="onButtonClick($event)">
    </app-button-group>
    <div class="ml-16">
      <app-close-button class="dark:!text-white" (onClick)="dialogRef.close()"></app-close-button>
    </div>
  </div>
  <div class="flex flex-grow h-full relative">
    <app-looker-embed-sdk
      [theme]="theme$ | async"
      [dashboard]="activeTab.dashboard"
      [hideAllFilters]="true"
      [filters]="dialogData.filters">
    </app-looker-embed-sdk>
  </div>
</div>
